import { render, staticRenderFns } from "./CreateGenre.vue?vue&type=template&id=4452710f&"
import script from "./CreateGenre.vue?vue&type=script&lang=js&"
export * from "./CreateGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports